import React from "react";

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: "default" | "secondary" | "outline";
  className?: string;
}

export const Badge = ({
  children,
  variant = "default",
  className = "",
  ...props
}: BadgeProps) => {
  return (
    <div className={`inline-flex items-center ${className}`} {...props}>
      {children}
    </div>
  );
};
